import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  href: string;
  prefetch?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function MonsterButtonLinkNext({ children, colorSwap, href, prefetch = true, target }: Props) {
  if (colorSwap) {
    return (
      <Link
        target={target}
        prefetch={prefetch}
        href={href}
        className='bg-monsterPurple hover:bg-monsterPurpleHover border-siteBackground nice-hover-burnout w-full rounded-lg border-2 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out'
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      target={target}
      prefetch={prefetch}
      href={href}
      className='bg-monsterGreen text-siteBackground hover:bg-monsterGreenHover border-siteBackground nice-hover-burnout w-full rounded-lg border-2 px-3 py-2 text-center font-bold transition-all duration-200 ease-in-out'
    >
      {children}
    </Link>
  );
}
